export const COMPANY = {
  name: "Cabsab.com",
  phoneDisplay: "+91 88722 37722",
  phoneTel: "+918872237722",
  whatsapp: "918872237722",
  email: "hello@cabsab.com",
  address: "Chandigarh, India",
};

export const buildWhatsAppUrl = (text) => {
  const encoded = encodeURIComponent(text);
  return `https://wa.me/${COMPANY.whatsapp}?text=${encoded}`;
};

export const SERVICE_TYPES = [
  { value: "One Way", label: "One Way" },
  { value: "Round Trip", label: "Round Trip" },
  { value: "Airport Transfer", label: "Airport Transfer" },
  { value: "Self Drive", label: "Self Drive" },
];

export const VEHICLE_CATEGORIES = [
  { value: "Hatchback", label: "Hatchback" },
  { value: "Sedan", label: "Sedan" },
  { value: "SUV", label: "SUV" },
  { value: "Self Drive", label: "Self Drive" },
];

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "Outstation", href: "#services" },
  { label: "One Way", href: "#services" },
  { label: "Airport Transfer", href: "#services" },
  { label: "Self Drive", href: "#services" },
  { label: "Contact", href: "#contact" },
];
